export default "__VITE_ASSET__a5cf516f__"